import type { TranslationKeys } from "@/hooks/useTranslation/catalogs"
import type { BillingPlanId } from "@/services/api/billingService"

export const PLAN_COPY: Record<
  BillingPlanId,
  {
    name: TranslationKeys
    /** Pro lists only what it adds: "everything in Starter" carries the rest */
    features: readonly TranslationKeys[]
    /** The one plan the picker highlights */
    recommended: boolean
  }
> = {
  starter: {
    name: "UPGRADE/PLAN_STARTER",
    features: [
      "UPGRADE/PLAN_STARTER_CREDITS",
      "UPGRADE/PLAN_FEATURE_TOOLS",
      "UPGRADE/PLAN_SEATS",
    ],
    recommended: false,
  },
  pro: {
    name: "UPGRADE/PLAN_PRO",
    features: ["UPGRADE/PLAN_PRO_EVERYTHING_IN_STARTER", "UPGRADE/PLAN_PRO_CREDITS"],
    recommended: true,
  },
}

/** Enterprise is sales-led: what it offers beyond the self-serve plans */
export const ENTERPRISE_FEATURES: readonly TranslationKeys[] = [
  "UPGRADE/ENTERPRISE_SEATS",
  "UPGRADE/ENTERPRISE_INVOICE",
  "UPGRADE/ENTERPRISE_TERMS",
]
